// extracted by mini-css-extract-plugin
export default {"item":"StatusItem_item__KBPYu","clickable":"StatusItem_clickable__vin+0"};